import { render, staticRenderFns } from "./AlarmRedirectPage.vue?vue&type=template&id=1ec59eab&"
import script from "./AlarmRedirectPage.vue?vue&type=script&lang=js&"
export * from "./AlarmRedirectPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports